import { Container } from '@/components/ui/container'
import { Separator } from '@/components/ui/separator'

interface ProPhotosGridProps {
	leftSlot: React.ReactNode
	rightSlot: React.ReactNode
}
export const ProPhotosGrid = ({ leftSlot, rightSlot }: ProPhotosGridProps) => {
	return (
		<Container fullHeight={false} fullWidth>
			<div className='grid h-full grid-cols-[minmax(0,2fr)_auto_minmax(0,1fr)]'>
				{leftSlot}

				<Separator
					className='mx-6 bg-neutral-300'
					orientation='vertical'
				/>

				{rightSlot}
			</div>
		</Container>
	)
}
ProPhotosGrid.displayName = 'ProPhotosGrid'
